<!--
 * @FileDescription: 商品排序
 * @Author: 陈文景
 * @Date: 2022-10-13 09:26:50
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <page-skeleton class="page-skeleton">
    <template slot="header-left">
      <div class="path">
        <span class="name">品类名称：</span>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item v-for="item in categoryPath" :key="item.id">{{ item.name }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </template>

    <template slot="container">
      <div class="category-cover">
        <h2>品类封面：</h2>
        <ul class="cover">
          <li v-for="(category, i) in categorys" :key="i" class="cover-item">
            <div class="cover-img-item">
              <img v-if="category.imgUrl" :src="category.imgUrl" alt="img.png" />
              <div v-if="[3,4].includes(category.status)" class="sold-out f-c-c">缺货</div>
              <div v-if="[0].includes(category.status)" class="sold-out f-c-c">下架</div>
              <div v-if="[2].includes(category.status)" class="sold-out f-c-c">删除</div>
              <span v-else>请设置封面图</span>
            </div>
            <div class="spu">
              <span>SPU：</span>
              <el-input v-model="category.spuCode" size="mini" placeholder="输入SPU" @change="changeCategoryCover(category)" />
            </div>
          </li>
          <!-- <li class="cover-item">
            <div class="cover-img-item">
              <img v-if="category[1].imgUrl" :src="category[1].imgUrl" alt="img.png" />
              <div v-if="[0,3,4].includes(category[1].status)" class="sold-out f-c-c">Sold Out</div>
              <span v-else>请设置封面图</span>
            </div>
            <div class="spu">
              <span>SPU：</span>
              <el-input v-model="category[1].spuCode" size="mini" placeholder="输入SPU" @change="() => changeCategoryCover(1)" />
            </div>
          </li>
          <li class="cover-item">
            <div class="cover-img-item">
              <img v-if="category[2].imgUrl" :src="category[2].imgUrl" alt="img.png" />
              <div v-if="[0,4].includes(category[2].status)" class="sold-out f-c-c">Sold Out</div>
              <span v-else>请设置封面图</span>
            </div>
            <div class="spu">
              <span>SPU：</span>
              <el-input v-model="category[2].spuCode" size="mini" placeholder="输入SPU" @change="() => changeCategoryCover(2)" />
            </div>
          </li> -->
        </ul>
      </div>

      <div class="sort-goods">
        <div class="sort-goods-head f--c">
          <h2>{{ `排序商品（${total}）：` }}</h2>
          <el-input v-model="parameter.spus" size="medium" clearable placeholder="支持通过SPU批量搜索(英文逗号隔开)" style="width:340px">
            <el-button slot="append" icon="el-icon-search" @click="getCategoryGoodsList" />
          </el-input>
          <!-- <div class="select-all">
            <el-button size="medium" round @click="handleClickIsSelectAll">{{ isSelectAll ? '取消全选' : '全选' }}</el-button>
            <el-select v-if="isSelectAll" v-model="move" size="medium" placeholder="请选择" @change="selectMoveType">
              <el-option v-for="item in moveOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
            <el-input-number v-if="move === 2" v-model="customize" controls-position="right" size="medium" step-strictly :min="1" :max="999" placeholder="请输入" @change="() => setCategoryCustomSort(getKkProductIds(), customize)" />
            <span v-if="isSelectAll" class="select-sum">
              已选择
              <span class="sum">{{ maskSum }}</span>
              个商品
            </span>
          </div> -->
        </div>
        <div class="sort">
          <!-- <ul id="drag" :class="{ 'stop-ul-event': maskSum === goods.length }">
            <li v-for="good in goods" :key="good.id" :data-id="good.kkProductId" class="drag-handle" :class="{ selected: good.isMask }">
              <div class="cover-img">
                <img :src="good.imgUrl" alt="img.png" />
                <div v-if="[3,4].includes(good.status)" class="sold-out f-c-c">缺货</div>
              </div>
              <div class="spu-info">
                <el-tooltip :enterable="true" effect="light" :content="good.spuCode" placement="top">
                  <p class="spu">SPU：{{ good.spuCode }}<i class="pointer iconfont el-icon-document-copy" @click="copy(good.spuCode)" /></p>
                </el-tooltip>
                <p class="price">
                  价格：<span>${{ good.price }}</span>
                </p>
                <div class="priority">
                  <span>优选级：</span>
                  <el-input-number v-model="good.productSort" controls-position="right" size="mini" step-strictly :min="1" :max="999" @change="(value) => handleChangePriority(good, value)" />
                </div>
              </div>
            </li>
          </ul> -->
          <goods ref="goodsComp" :data="goods" :show-fixed="false" :showDelete="false" :showPriority="true" :avoidImplicitDeselect="true" @select="onSelect" @end="onEnd" @changePriority="handleChangePriority" style="margin-top:20px" />
        </div>
      </div>
    </template>

    <template #footer-right>
      <el-pagination background :page-sizes="[20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper" :total="total" :current-page="parameter.pageNumber" @size-change="sizeChange" @current-change="currentChange" />
    </template>
  </page-skeleton>
</template>

<script>
import API from '@/api'
import { replaceStr } from '@/utils'
import { Sortable } from 'sortablejs'
import uniqueId from 'lodash/uniqueId'
import PageSkeleton from '@/components/PageSkeleton.vue'
import { copy } from '@/utils'
import Goods from '@/components/Goods.vue'
// let goods = []

// for (let i = 0; i < 20; i++) {
//   goods.push({
//     id: i,
//     isMask: false,
//     imgUrl: 'https://fuss10.elemecdn.com/3/28/bbf893f792f03a54408b3b7a7ebf0jpeg.jpeg',
//     kkProductId: i, // 商品ID
//     spuCode: `FSZW07025${i}`,
//     price: `${i}00`,
//     productSort: `${i}` // 优先级
//   })
// }

export default {
  components: {
    'page-skeleton': PageSkeleton,
    Goods
  },
  data() {
    return {
      // 获取商品列表的请求参数
      parameter: {
        categoryId: undefined, // 品类ID
        spus: undefined, // 搜索条件
        pageSize: 20,
        pageNumber: 1
      },

      categoryPath: [], // 品类全路径

      // 品类封面数据源
      categorys: [],
      // category: [
      //   { spuCode: undefined, imgUrl: undefined },
      //   { spuCode: undefined, imgUrl: undefined },
      //   { spuCode: undefined, imgUrl: undefined }
      // ],

      keyword: undefined, // 搜索SPU关键字

      isSelectAll: false, // 是否全选

      customize: undefined, // 自定义排序

      move: undefined, // 移动选择下拉框双向绑定的值
      // 移动选项下拉框选项
      moveOptions: [
        { label: '自定义排序', value: 2 },
        { label: '移动至首页顶部', value: 1 },
        { label: '移动至尾页底部', value: 999 }
      ],

      selectIndex: [], // 当前列表排序中已选中的元素索引

      goods: [], // 商品列表
      total: 0, // 商品列表总数量
      loading: false // 表格loading
    }
  },
  created() {
    this.getFrontCover(this.$route.query.categoryId)
    this.getCategoryPath(this.$route.query.categoryId)
    this.parameter.categoryId = this.$route.query.categoryId
    this.getCategoryGoodsList()
  },
  computed: {
    maskSum() {
      let sum = 0
      this.goods.forEach((item) => {
        if (item.isMask) {
          sum++
        }
      })
      return sum
    }
  },
  methods: {
    /**
     * API 获取商品列表
     * @param {Boolean} reset 是否重置分页
     */
    async getCategoryGoodsList(reset = true) {
      try {
        if (reset) {
          this.parameter.pageNumber = 1
        }
        this.loading = true
        let { data } = await API.getCategoryGoodsList({ ...this.parameter, spus: replaceStr(this.parameter.spus) ? replaceStr(this.parameter.spus).split(',') : [] })
        this.total = data.total
        this.goods = data.list.map((item) => {
          item.id = item.kkProductId
          item.isMask = false
          item.images = `${item.imgUrl}?x-oss-process=image/resize,w_148,h_147,m_fill/format,webp`
          item.priority = item.productSort
          item.oldPriority = item.productSort
          return item
        })
        this.move = undefined
        this.isSelectAll = false
        this.loading = false

        this.$nextTick(() => {
          this.resetGoods()
        })
      } catch (error) {
        this.loading = false
      }
    },

    /**
     * API 获取品类全路径
     * @param {Number} categoryId 品类ID
     */
    async getCategoryPath(categoryId) {
      let { data } = await API.getCategoryPath({ categoryId })
      this.categoryPath = data.split('/').map((item) => {
        return {
          id: uniqueId(),
          name: item
        }
      })
    },

    /**
     * API 自定义排序
     * @param {*} kkProductIds 商品IDs
     * @param {*} index 排序级别
     */
    async setCategoryPriority(param) {
      param.categoryId = this.$route.query.firstCategoryId
      let { code, message } = await API.setCategoryPriority(param)
      if (code === 10000) {
        this.$message.success(message)
        this.getCategoryGoodsList(false)
      } else {
        this.$message.error(message)
      }
    },

    /**
     * API 根据品类ID获取封面图
     */
    async getFrontCover(categoryId) {
      let { data } = await API.getFrontCover({ categoryId })
      if (data) {
        for (let i = 0; i < 3 ;i++) {
          if (!data[i]) {
            // 自动补齐三位
            data[i] = { spuCode: undefined, imgUrl: undefined }
          }
        }
        this.categorys = data;
        // this.category[0].imgUrl = data[0] && data[0].imgUrl
        // this.category[0].spuCode = data[0] && data[0].spuCode
        // this.category[0].kkProductId = data[0] && data[0].kkProductId
        // this.category[0].status = data[0] && data[0].status
        // this.category[1].imgUrl = data[1] && data[1].imgUrl
        // this.category[1].spuCode = data[1] && data[1].spuCode
        // this.category[1].kkProductId = data[1] && data[1].kkProductId
        // this.category[1].status = data[1] && data[1].status
        // this.category[2].imgUrl = data[2] && data[2].imgUrl
        // this.category[2].spuCode = data[2] && data[2].spuCode
        // this.category[2].kkProductId = data[2] && data[2].kkProductId
        // this.category[2].status = data[2] && data[2].status
      }
    },

    /**
     * API 设置封面图
     * @param {String} spuCode spuCode
     * @param {*} oldKkProductId 旧的kkProductId
     */
    async setFrontCover(spuCode, oldKkProductId) {
      let { code, message } = await API.setFrontCover({ spuCode, oldKkProductId, categoryId: this.parameter.categoryId })
      if (code === 10000) {
        this.getFrontCover(this.$route.query.categoryId)
        this.$message.success(message)
      } else {
        this.$message.error(message)
      }
    },
    copy,
    /**
     * 品类封面SPU输入框失去焦点或按下回车键的回调
     */
    changeCategoryCover(category) {
      this.setFrontCover(category.spuCode, category.kkProductId)
      // switch (type) {
      //   case 0:
      //     this.setFrontCover(this.category[0].spuCode, this.category[0].kkProductId)
      //     break
      //   case 1:
      //     this.setFrontCover(this.category[1].spuCode, this.category[1].kkProductId)
      //     break
      //   case 2:
      //     this.setFrontCover(this.category[2].spuCode, this.category[2].kkProductId)
      //     break
      // }
    },

    // /**
    //  * 全选/取消全选按钮的回调
    //  */
    // handleClickIsSelectAll() {
    //   this.move = undefined
    //   this.customize = undefined
    //   this.isSelectAll = !this.isSelectAll
    //   this.goods.forEach((item) => {
    //     item.isMask = this.isSelectAll
    //   })
    // },

    /**
     * 选择移动类型的事件回调
     */
    selectMoveType() {
      if (this.move === 2) return
      this.customize = undefined
      let kkProductIds = this.getKkProductIds()
      this.setCategoryCustomSort(kkProductIds, this.move)
    },
    getKkProductIds() {
      return this.goods
        .map((item) => {
          if (item.isMask) {
            return item.kkProductId
          }
        })
        .filter(Boolean)
    },

    /**
     * 某个商品的优先级发生改变时的事件回调
     * @param {Object} good 发生改变的商品对象
     * @param {Number} value 最新的值
     */
    handleChangePriority(good) {
      this.setCategoryPriority({
        index: good.orderNum,
        update: good.update,
        oldIndex: good.oldPriority
      })
    },

    /**
     * 每页显示条数发生改变时的回调
     * @param {Number} size 每页显示条数
     */
    sizeChange(size) {
      this.parameter.pageSize = size
      this.getCategoryGoodsList(false)
    },

    /**
     * 上一页/下一页/当前页发生改变时的回调
     * @param {Number} current 当前页
     */
    currentChange(current) {
      this.parameter.pageNumber = current
      this.getCategoryGoodsList(false)
    },

    // 重置拖拽组件
    resetGoods() {
      this.$refs.goodsComp.destroySortable()
    },

    /**
    * 选中商品时触发的事件回调
    *
    * @param {Array} selectIds 当前选中的商品IDs
    */
    onSelect(selectIds) {
      this.selectIds = selectIds
    },

    /**
    * 拖拽结束后触发的事件回调
    *
    * @param {Array} selectIds 当前选中的商品IDs
    * @param {Array} sortIds 当前列表排序后的IDs（未包含置顶元素）
    * @param {Array} ids 当前列表排序后的IDs
    */
    onEnd(selectIds, sortIds, ids) {
      let param = {
        categoryId: this.parameter.categoryId
      }
      param.pageNumber = this.parameter.pageNumber
      param.pageSize = this.parameter.pageSize
      param.update = ids
      API.setCategoryCustomSort(param).then(res => {
        this.$message.success('操作成功')
        this.getCategoryGoodsList(false)
      })
    },

    // // 批量操作
    // handleCommand(command) {
    //   if (!this.selectIds.length) return this.$message.warning('请先选择商品！') 
    //   switch (command) {
    //     case 1:
    //       this.$refs.batchPriority.show()
    //       return
    //     case 2:
    //       this.$confirm('确定要删除选择的商品吗', {
    //         type: 'warning'
    //       }).then(() => {
    //         this.editHandle('delete', { kkProductIds: this.selectIds })
    //       })
    //       return
    //   }
    // }
  }
}
</script>

<style lang="scss" scoped>
.page-skeleton {
  height: unset !important;
  min-width: 1400px;
  /deep/ section {
    height: unset !important;
  }
}
</style>
<style lang="scss" scoped>
.path {
  position: relative;
  display: flex;
  align-items: center;
  color: #606266;
  .name {
    font-size: 15px;
    font-weight: 600;
    padding-left: 8px;
  }
}

.path .name,
.category-cover h2,
.sort-goods h2 {
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 2px;
    height: 100%;
    background-color: #99c41c;
  }
}

.category-cover {
  color: #606266;
  h2 {
    position: relative;
    font-size: 15px;
    font-weight: 600;
    padding-left: 8px;
    margin-top: 10px;
    margin-bottom: 18px;
  }
  .cover {
    width: 100%;
    padding-left: 38px;
    .cover-item {
      width: 150px;
      display: inline-block;
      box-sizing: border-box;
      border: 1px dashed #99c41c;
      border-radius: 4px;
      overflow: hidden;
      &:nth-child(2) {
        margin: 0 18px;
      }
      .cover-img-item {
        width: 100%;
        height: 148px;
        color: #a8acb1;
        line-height: 148px;
        text-align: center;
        border-bottom: 1px dashed #99c41c;
        user-select: none;
        position: relative;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .sold-out {
          width: 80%;
          height: 22px;
          border-radius: 4px;
          background-color: #F4F6F9;
          color: #8B93A3;
          line-height: 22px;
          text-align: center;
          position: absolute;
          bottom: 4px;
          left: 0;
          right: 0;
          margin: auto;
          opacity: .8;
        }
      }
      .spu {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 5px;
        span {
          font-size: 13px;
        }
      }
    }
  }
}

.sort-goods {
  color: #606266;
  .sort-goods-head {
    margin-top: 35px;
    margin-bottom: 18px;

    .el-input {
      width: 338px;
      /deep/.el-input__inner {
        border-top-left-radius: 18px;
        border-bottom-left-radius: 18px;
      }
      /deep/.el-input-group__append {
        border-top-right-radius: 18px !important;
        border-bottom-right-radius: 18px !important;
      }
    }
    .select-all {
      margin: 0 20px;
      .el-select {
        margin: 0 18px;
        /deep/.el-input__inner {
          border-radius: 18px;
        }
      }
      .select-sum {
        margin-left: 18px;
        .sum {
          color: #f56c6c;
          font-size: 600;
        }
      }
    }
  }
  h2 {
    position: relative;
    font-size: 15px;
    font-weight: 600;
    padding-left: 8px;
  }
  .sort {
    padding-left: 38px;

    ul {
      display: grid;
      width: 100%;
      // max-height: calc(100vh - 601.5px);
      flex-wrap: wrap;
      padding-top: 18px;
      padding-left: 18px;
      border: 1px solid #99c41c;
      border-radius: 4px;
      // overflow-y: auto;
      user-select: none;
      li {
        position: relative;
        width: 150px;
        margin: 0 18px 18px 0;
        border: 1px dashed #99c41c;
        border-radius: 4px;
        overflow: hidden;
        cursor: pointer;
        &.selected {
          border: 1px solid #f56c6c;
        }
        .cover-img {
          width: 100%;
          height: 148px;
          line-height: 148px;
          text-align: center;
          border-bottom: 1px dashed #99c41c;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          .sold-out {
          width: 80%;
          height: 22px;
          border-radius: 4px;
          background-color: #F4F6F9;
          color: #8B93A3;
          line-height: 22px;
          text-align: center;
          position: absolute;
          bottom: 90px;
          left: 0;
          right: 0;
          margin: auto;
          opacity: .8;
        }
        }
        .spu-info {
          padding: 5px;
          font-size: 13px;
          .spu {
            display: inline-block;
            width: 100%;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          .price {
            margin: 5px 0;
            span {
              color: #f56c6c;
            }
          }
          .priority {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .el-input-number {
              width: 80px;
            }
          }
        }
      }
    }
    .stop-ul-event {
      pointer-events: none;
    }
  }
}
.el-icon-document-copy{
  margin-left: 2px;
//   color: blue
}

.enable {
  color: #99c41c;
}

.disable {
  color: #f56c6c;
}

/deep/.el-input-number {
  .el-input__inner {
    padding-left: 4px;
    padding-right: 32px;
  }
}
</style>
